import React, { useEffect } from "react"
import { View } from "react-native"
import Animated, {
    Easing,
    runOnJS,
    useAnimatedStyle,
    useSharedValue,
    withDelay,
    withSequence,
    withTiming,
} from "react-native-reanimated"
import { theme } from "../../theme/theme"
import TextM from "../text/TextM"

export function CounterWrapper(props) {
    const {
        title,
        children,
        style,
        titleStyle,
        contentStyle,
        borderColor = theme.colors.primary,
        small = false,
        width = 120,
        animationDelay = 0,
        onAnimationComplete = () => {},
        isVisible = true,
    } = props

    const scale = useSharedValue(0)
    const opacity = useSharedValue(0)

    const animatedStyles = useAnimatedStyle(() => ({
        transform: [{ scale: scale.value }],
        opacity: opacity.value,
    }))

    useEffect(() => {
        if (isVisible) {
            const animationDuration = 400

            opacity.value = withDelay(
                animationDelay,
                withTiming(1, { duration: animationDuration / 2 })
            )

            scale.value = withDelay(
                animationDelay,
                withSequence(
                    withTiming(0, { duration: 0 }),
                    withTiming(1.1, {
                        duration: animationDuration * 0.7,
                        easing: Easing.out(Easing.back(1.5)),
                    }),
                    withTiming(
                        1,
                        {
                            duration: animationDuration * 0.3,
                        },
                        (finished) => {
                            if (finished) {
                                runOnJS(onAnimationComplete)()
                            }
                        }
                    )
                )
            )
        }
    }, [isVisible, animationDelay])

    return (
        <Animated.View
            style={[
                {
                    alignItems: "center",
                    justifyContent: "center",
                    marginHorizontal: 4,
                    width: width,
                    maxWidth: "100%",
                    ...style,
                },
                animatedStyles,
            ]}
        >
            <View
                style={{
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: borderColor,
                    borderRadius: 12,
                    paddingHorizontal: 4,
                    paddingBottom: 4,
                    alignSelf: "center",
                    height: 80,
                    width: "100%",
                    overflow: "hidden",
                }}
            >
                <TextM
                    fontSize={small ? 12 : 14}
                    fontWeight="Bold"
                    color={theme.colors.white}
                    style={{
                        textTransform: "uppercase",
                        marginVertical: "auto",
                        textAlign: "center",
                        ...titleStyle,
                    }}
                    wrap
                >
                    {title}
                </TextM>
                <View
                    style={{
                        borderWidth: 2,
                        borderColor: borderColor,
                        borderRadius: 8,
                        alignItems: "center",
                        justifyContent: "center",
                        paddingVertical: 8,
                        paddingHorizontal: 16,
                        backgroundColor: theme.colors.white,
                        ...contentStyle,
                        width: "100%",
                        overflow: "hidden",
                    }}
                >
                    {children}
                </View>
            </View>
        </Animated.View>
    )
}
